<template>
  <div class="dialog-content">
    <el-row class="dialog-content">
      <el-col :lg="12" style="height:100%; border-right: 1px solid rgba(41, 155, 255, .2)">
        <div class="deviceDetailContentHeight bg-color">
          <div style="padding: 15px 0; overflow-y:auto;height: 100%;">
            <img style="width: 90%;padding-left: 12%;padding-top: 18%;"
                 v-if="gateData.carPic === null || gateData.carPic === '' " src="../../assets/images/noteCat.png"/>
            <img style="width: 90%;padding-left: 12%;padding-top: 18%;" v-else :src="gateData.carPic"/>
            <gate-control :deviceInfo="deviceInfo" @control="control" :code="gateData.code"></gate-control>
          </div>
        </div>

      </el-col>
      <el-col :lg="12" style="height: 100%">
        <div class="deviceDetailContentHeight text-center">
          <div class="bg-color" style="overflow-y:auto;width: 100%;height: 100%;padding-top: 25%;">
            <point-layout :point-data="otherHistoryData"/>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PointLayout from "@/components/device_details/comp/PointLayout";
import GateControl from "@/components/device_details/comp/GateControl";
import {getParkingGate} from "@/network/car-access";

export default {
  name: "Parking",
  components: {PointLayout, GateControl},
  props: ['deviceInfo', 'alarmInfoList'],
  data() {
    return {
      pointData: [],
      pointCodes: [],
      portProperties: null,
      historyData: [],
      otherHistoryData: [],
      operationList: [],
      gateData: {},
      flag: false,
    }
  },
  mounted() {
    this.getGateData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getAirConditioner:5000': this.getPointData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getAirConditioner')
  },
  methods: {
    getGateData() {
      getParkingGate(this.deviceInfo.note).then(res => {
        this.otherHistoryData = res.data.parkingPoints;
        this.gateData = res.data.parkingGate;
      })
    },
    control() {
      this.getGateData();
    },
    change: function () {
      this.flag = !this.flag
    }
  }
}
</script>

<style scoped>

.device-base {
  width: 100%;
  padding: 70px 0 0 20px;
}

.device-img {
  height: 163px;
  width: 142px;
  margin: auto;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}

.device-main {
  margin-top: 10px;
}

.borderLeft {
  border-left: 1px solid rgba(41, 155, 255, 0.2);
}

/*测点详情*/
.cross-line {
  width: 0;
  margin-top: 30px;
  height: 135px;
  border: 1px solid rgba(41, 155, 255, 0.2);
}

.device-main .img {
  margin: 0 auto 0 auto;
  background-repeat: no-repeat;
  background-position: center 0;
  height: 35px;
  width: 21px;
}


li {
  width: 290px;
  float: left;
  margin-left: 50px;
  margin-top: 20px;
  list-style: none;
}
</style>
